<script>
  import { auth, resendEmailVerification } from '../state/auth.svelte.js';

  let sending = $state(false);
  let sent = $state(false);

  const show = $derived(
    auth.isLoggedIn && auth.emailVerified === false && !auth.emailBannerDismissed
  );

  async function resend() {
    if (sending) return;
    sending = true;
    const ok = await resendEmailVerification();
    sending = false;
    if (ok) sent = true;
  }
</script>

{#if show}
  <div class="verify-banner" role="status">
    <span class="verify-text">
      {#if sent}
        ✓ Verification email sent to <strong>{auth.email}</strong>. Check your inbox.
      {:else}
        Please verify your email{auth.email ? ` (${auth.email})` : ''} to secure your account.
        <button class="verify-btn" onclick={resend} disabled={sending}>
          {sending ? 'Sending…' : 'Resend email'}
        </button>
      {/if}
    </span>
    <button
      class="verify-dismiss"
      onclick={() => (auth.emailBannerDismissed = true)}
      aria-label="Dismiss"
    >✕</button>
  </div>
{/if}

<style>
  .verify-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: #e7f5ff;
    border-bottom: 1px solid #74c0fc;
    color: #1864ab;
    text-align: center;
    padding: 0.6rem 2.5rem 0.6rem 1rem;
    font-size: 0.875rem;
    position: relative;
  }

  .verify-btn {
    background: none;
    border: none;
    color: #1864ab;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
    font-size: inherit;
    padding: 0;
  }

  .verify-btn:disabled { opacity: 0.6; cursor: default; }

  .verify-dismiss {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #1864ab;
    opacity: 0.7;
    cursor: pointer;
    font-size: 0.875rem;
    padding: 0.5rem;
    line-height: 1;
  }

  .verify-dismiss:hover { opacity: 1; }

  @media (max-width: 639px) {
    .verify-banner { font-size: 0.75rem; padding: 0.5rem 2.25rem 0.5rem 0.75rem; }
  }
</style>
